export default "__VITE_ASSET__B1pu8E2X__"